// Account route (/account, any signed-in user): profile, password and active sessions; the screen is AccountPage.
import { createFileRoute } from "@tanstack/react-router";

import { AccountPage } from "@/features/account/AccountPage";

export const Route = createFileRoute("/_app/account")({
  staticData: { crumb: "Account" },
  component: AccountPage,
});
